import { batch } from 'react-redux';

import { getIsAbnLoyaltyProgramEnabled } from '~/src/features/domru-bonus/constants/abnVariants';
import { TAppThunkDispatch, TGetState } from '~/src/store';

import { fillBonusesValue, togglePayWithBonusesStatus } from '../actionCreators';

import validatePaymentSum from './validatePaymentSum';

const isAbnProgramTermsEnabled = getIsAbnLoyaltyProgramEnabled();

type TCalculateNotEditedBonusesValue = {
    paymentSum: number,
    availableBonuses: number,
}

const calculateNotEditedBonusesValue = ({ paymentSum, availableBonuses }: TCalculateNotEditedBonusesValue) => {
    if (isAbnProgramTermsEnabled) {
        const requiredBonusesToPay = paymentSum / 0.2;

        return (requiredBonusesToPay > availableBonuses)
            ? availableBonuses
            : requiredBonusesToPay;
    }

    return (paymentSum > availableBonuses)
        ? availableBonuses
        : Math.trunc(paymentSum);
};

const calculateByUseBonuses = (isTouchedBonusInput: boolean) => {
    return (dispatch: TAppThunkDispatch, getState: TGetState): void => {
        const {
            loyalty: { info: { bonuses: availableBonuses } },
            payment: { paymentData: { paymentSum, bonusesValue, isUseBonuses } },
        } = getState();

        dispatch(togglePayWithBonusesStatus(!isUseBonuses));

        const notEditedBonusesValue = calculateNotEditedBonusesValue({
            availableBonuses,
            paymentSum,
        });

        const bonusesSum = isUseBonuses
            ? 0
            : isTouchedBonusInput
                ? bonusesValue
                : notEditedBonusesValue;

        batch(() => {
            dispatch(fillBonusesValue(bonusesSum));
            dispatch(validatePaymentSum());
        });
    };
};

export default calculateByUseBonuses;
